import { render, staticRenderFns } from "./indexGallery.vue?vue&type=template&id=d186282c&scoped=true"
import script from "./indexGallery.vue?vue&type=script&lang=js"
export * from "./indexGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d186282c",
  null
  
)

export default component.exports